import {
	UserOutlined
} from '@ant-design/icons';
import { Avatar, Col, Dropdown, Layout, Menu, Row, Typography } from 'antd';
import 'moment/locale/ru';
import 'rc-banner-anim/assets/index.css';
import React, { useEffect, useState } from 'react';
import Icofont from 'react-icofont';
import { useDispatch, useSelector } from 'react-redux';
import {
	Link,
	Navigate,
	Route,
	Routes,
	useLocation
} from "react-router-dom";
import { useAuth } from '../../components/Auth';
import { UserContext } from '../../components/Context';
import { errorCatch, GET, HasRole, JSXMap } from '../../components/Tool';
import Dashboard from '../Dashboard';
import Service from "../Service";
import ServiceDone from '../ServiceDone';
import ServiceDoneDescription from '../ServiceDoneDescription';
import ServiceParameters from '../ServiceParameters';
import Services from "../Services";
import SystemServices from "../SystemServices";
import SystemStates from "../SystemStates";
import SystemFunctions from "../SystemFunctions";
import SystemScheme from "../SystemScheme";
import SystemQuestions from "../SystemQuestions"


import DictionaryPage from "../DictionaryPage"
import TechnicsPage from "../TechnicsPage"
import EnumsPage from "../EnumsPage"

import "./index.less";
import SystemAnswers from '../SystemAnswers';
import Enums from '../Enums';
import Technics from '../Technics';
import Dictionary from '../Dictionary';
import SystemGroups from '../SystemGroups';
import Agrotechnology from '../Agrotechnology';


const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;

export default function Home(props) {
	const auth = useAuth();
	const { pathname } = useLocation();

	const dispatch = useDispatch();
	const user = useSelector(state => state.home.user);
	const meta = useSelector(state => state.meta);
	const [collapsed, setCollapsed] = useState(false);
	useEffect(
		() => {
			if (dispatch) {
				GET(auth, '/api/meta', res => {
					if (res && res.data) {
						dispatch({ type: 'META', payload: res.data })
					}
				}, errorCatch);
				GET(auth, '/api/iam', res => {
					if (res && res.data) {
						dispatch({ type: 'USER', payload: res.data })
					}
				}, errorCatch);
			}

			// auth.openSocket("/ws/service", "service", function (type, payload) {
			// 	if (type === "reload") {
			// 		var href = window.location.href
			// 		window.location.href = href;
			// 	}
			// 	switch (type) {
			// 		case "value":
			// 			break;
			// 		default:
			// 			break;
			// 	}
			// });
			return () => {
				// auth.closeSocket("service");
			};
		},
		[auth, dispatch]
	);
	const onCollapse = collapsed => {
		setCollapsed(collapsed);
	};
	const logout = () => {
		auth.logout(() => {
			window.location.href = "/app";
		});
	}
	return (
		<UserContext.Provider value={user}>
			<Layout style={{ minHeight: '100vh' }}>
				<Sider collapsible collapsed={collapsed} onCollapse={onCollapse} width={"250px"}>
					<div className={(collapsed) ? "logo-small" : "logo"} />
					<Menu theme="dark" defaultSelectedKeys={[pathname]} mode="inline">
						<Menu.Item key="/app/services" icon={<Icofont icon="cubes" />}>
							<Link to="services">Сервисы</Link>
						</Menu.Item>
						<Menu.Item key="/app/agrotechnology" icon={<Icofont icon="attachment" />}>
							<Link to="agrotechnology">Агротехнология</Link>
						</Menu.Item>
						

						{(HasRole(user, ['root', 'admin']) && meta) &&
							<SubMenu key="/app/dictionary" icon={<Icofont icon="document-folder" />} title="Справочники" style={{ backgroundColor: "darkslategrey" }}>
								{JSXMap([
									"Crops",
									"Sorts",
									"CropRegion",
									// "CropParameter",
								], (name, idx) => {
									let e = meta[name.toLowerCase()];
									if(!e) return (undefined);
									return (<Menu.Item key={name.toLowerCase()} icon={<Icofont icon="listine-dots" />}>
										<Link to={`dictionary/${e.name.toLowerCase()}`}>{e.label}</Link>
									</Menu.Item>)
								})}

							</SubMenu>
						}
						{(HasRole(user, ['root', 'admin']) && meta) &&
							<SubMenu key="/app/technics" icon={<Icofont icon="vehicle-dozer" />} title="Техника" style={{ backgroundColor: "darkslategrey" }}>
								{JSXMap([
									"VnesenieZhidkikhUdobrenii",
									"Yemkosti",
									"Zhatki",
									"Traktori",
									"BunkeriPeregruzchiki",
									"GruzovieAvtomobili",
									"Kombaini",
									"Opriskivateli",
									"PochvoobrabativayushchieOrudiya",
									"Podborshchiki",
									"Pogruzchiki",
									"Protraviteli",
									"Razbrasivateli",
									"Seyalki"
								], (name, idx) => {
									let e = meta[name.toLowerCase()];
									if(!e) return (undefined);
									return (<Menu.Item key={name.toLowerCase()} icon={<Icofont icon="listine-dots" />}>
										<Link to={`technics/${e.name.toLowerCase()}`}>{e.label}</Link>
									</Menu.Item>)
								})}

							</SubMenu>
						}
						{(HasRole(user, ['root', 'admin']) && meta) &&
							<SubMenu key="/app/enums" icon={<Icofont icon="listing-box" />} title="Перечисления" style={{ backgroundColor: "darkslategrey" }}>
								{JSXMap([
									"Proizvoditel",
									"TipBunkeraPeregruzchika",
									"TipGruzovogoAvtomobilya",
									"TipKombaina",
									"TipOpriskivatelya",
									"TipPochvoobrabativayushchegoOrudiya",
									"TipPodborshchika",
									"TipPogruzchika",
									"TipProtravitelya",
									"TipRazbrasivatelya",
									"TipSeyalki",
									"TipVnesenieZhidkikhUdobrenii",
									"TipYemkosti",
									"TipZhatki",
									"TyagoviiKlass",
									"VidPochvoobrabativayushchegoOrudiya",
									"VidTraktora",
								], (name, idx) => {
									let e = meta[name.toLowerCase()];
									if(!e) return (undefined);
									return (<Menu.Item key={name.toLowerCase()} icon={<Icofont icon="listine-dots" />}>
										<Link to={`enums/${e.name.toLowerCase()}`}>{e.label}</Link>
									</Menu.Item>)
								})}

							</SubMenu>
						}
						{HasRole(user, 'root') &&
							<SubMenu key="/app/system" icon={<Icofont icon="automation" />} title="Система" style={{ backgroundColor: "darkslategrey" }}>
								<Menu.Item key="/app/system/services" icon={<Icofont icon="cubes" />}>
									<Link to="system/services">Сервисы</Link>
								</Menu.Item>
								<Menu.Item key="/app/system/questions" icon={<Icofont icon="question-square" />}>
									<Link to="system/questions">Вопросы</Link>
								</Menu.Item>
								<Menu.Item key="/app/system/answers" icon={<Icofont icon="question-square" />}>
									<Link to="system/answers">Ответы</Link>
								</Menu.Item>
								<Menu.Item key="/app/system/states" icon={<Icofont icon="pixels" />}>
									<Link to="system/states">Состояния</Link>
								</Menu.Item>
								<Menu.Item key="/app/system/functions" icon={<Icofont icon="chart-flow-2" />}>
									<Link to="system/functions">Функции</Link>
								</Menu.Item>
								<Menu.Item key="/app/system/scheme" icon={<Icofont icon="connection" />}>
									<Link to="system/scheme">Схемы</Link>
								</Menu.Item>
								<Menu.Item key="/app/system/groups" icon={<Icofont icon="connection" />}>
									<Link to="system/groups">Группы</Link>
								</Menu.Item>
							</SubMenu>
						}
					</Menu>
				</Sider>
				<Layout className="site-layout">
					<Header className="site-layout-background" style={{ padding: 0 }}>
						<div style={{ float: "right" }}>
							{user && <div style={{ float: "right", paddingRight: "15px" }}>
								<Dropdown overlay={
									<Menu>
										<Menu.Item key="2" onClick={logout}>
											<Icofont icon="logout" style={{ paddingRight: "5px" }} />Выход
										</Menu.Item>
									</Menu>
								}>
									<Row style={{ cursor: "pointer" }}>
										<Col style={{ lineHeight: "20px", textAlign: "right" }}>
											<Typography style={{ padding: "12px 15px 0px 0px", fontWeight: "600" }}>
												{user.lastname} {user.firstname}
											</Typography>
											<Typography style={{ padding: "0 15px", fontSize: "12px" }}>
												{user.email}
												{/* {(user.utype)?user.utype.name:""} */}
											</Typography>
										</Col>
										<Col>
											<Avatar shape="square" size="large" icon={<UserOutlined style={{ padding: 0 }} />} />
										</Col>
									</Row>
								</Dropdown>
							</div>}
						</div>
					</Header>
					<Content>
						<Routes>
							{/* <Route exact path="/" element={<Dashboard />} /> */}
							<Route path="/" element={<Navigate replace to="services" />} />
							<Route path="services" element={<Services />} />
							<Route path="services/:id" element={<Service />}>
								<Route index element={<ServiceParameters />} />
								<Route path="done" element={<ServiceDone />} />
								<Route path="done/:num" element={<ServiceDoneDescription />} />
							</Route>
							<Route path="agrotechnology" element={<Agrotechnology />} />

							{HasRole(user, ['root', 'admin']) && <>
								<Route path="dictionary/:name" element={<Dictionary />}>
									<Route index element={<DictionaryPage />} />
								</Route>
							</>}
							{HasRole(user, ['root', 'admin']) && <>
								<Route path="technics/:name" element={<Technics />}>
									<Route index element={<TechnicsPage />} />
								</Route>
							</>}
							{HasRole(user, ['root', 'admin']) && <>
								<Route path="enums/:name" element={<Enums />}>
									<Route index element={<EnumsPage />} />
								</Route>
							</>}
							{HasRole(user, 'root') &&
								<Route path="system/services" element={<SystemServices />} />
							}
							{HasRole(user, 'root') &&
								<Route path="system/questions" element={<SystemQuestions />} />
							}
							{HasRole(user, 'root') &&
								<Route path="system/answers" element={<SystemAnswers />} />
							}
							{HasRole(user, 'root') &&
								<Route path="system/states" element={<SystemStates />} />
							}
							{HasRole(user, 'root') &&
								<Route path="system/functions" element={<SystemFunctions />} />
							}
							{HasRole(user, 'root') &&
								<Route path="system/scheme" element={<SystemScheme />} />
							}
							{HasRole(user, 'root') &&
								<Route path="system/groups" element={<SystemGroups />} />
							}
							<Route
								path="*"
								element={
									<main style={{ padding: "1rem" }}>
										<p>Упс, тут ничего нет!</p>
									</main>
								}
							/>
						</Routes>
					</Content>
					<Footer style={{ textAlign: 'center', padding: "10px 50px" }}></Footer>
				</Layout>
			</Layout>
		</UserContext.Provider>
	);
};